export default __webpack_public_path__ + "static/media/Logo-PNG.f096343f.png";